import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useEdition } from "@/hooks/useEdition";
import { ReaderContext } from "@/components/magazine/ReaderContext";
import { MagazinePage } from "@/components/magazine/MagazinePage";

export default function Print() {
  const { lang } = useParams();
  const { edition, pages } = useEdition(lang);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!pages.length) return;
    let alive = true;
    const imgs = Array.from(document.images);
    Promise.all([
      document.fonts?.ready,
      ...imgs.map((im) => (im.complete ? null : new Promise((r) => { im.onload = r; im.onerror = r; }))),
    ]).then(() => alive && setReady(true));
    return () => { alive = false; };
  }, [pages]);

  return (
    <ReaderContext.Provider value={{ goTo: () => {}, openMedia: null, ui: edition?.ui || {}, edition, interactive: false }}>
      <style>{`@page { size: 600px 848px; margin: 0; } html, body { background: #fff; margin: 0; } .print-page { width: 600px; height: 848px; overflow: hidden; break-after: page; page-break-after: always; } .print-page:last-child { break-after: auto; page-break-after: auto; }`}</style>
      <div data-testid="print-root" data-print-ready={ready ? "true" : "false"} lang={lang} dir={edition?.dir || "ltr"}>
        {pages.map((p) => (
          <div key={p.n} className="print-page"><MagazinePage page={p} /></div>
        ))}
      </div>
    </ReaderContext.Provider>
  );
}
